import React, { useState } from 'react';
import Header from '../Component/Header'
import Footer from '../Component/Footer'

function Contact() {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const message = `Hello, I would like to inquire about the following:

        Name: ${formData.name}
        Surname: ${formData.Surname}
        Subject: ${formData.subject}
        Message: ${formData.message}`;

        const encodedMessage = encodeURIComponent(message);
        const phoneNumber = '+919274790059'; // your WhatsApp number
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(whatsappURL, '_blank');
  
        // ✅ Clear form after sending
        setFormData({
        name: '',
        Surname: '',
        subject: '',
        message: ''
  });
};

    return (
        <>
            <Header />
            <div style={{ backgroundColor: "#FFFFFF" }}>
                {/* Header Start */}
                <div className="container-fluid hero-header mt-4">
                    <div className="container py-5">
                    </div>
                </div>
                {/* Header End */}
                {/* Contact Start */}
                <div className="container">
                    <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: 500 }}>
                        <h1 className="display-6 mb-5">If You Have Any Query, Please Contact Us</h1>
                    </div>
                    <div className="row g-3 justify-content-center">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                placeholder="First Name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            <label htmlFor="name">First Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="Surname"
                                                placeholder="Last Name"
                                                value={formData.Surname}
                                                onChange={handleChange}
                                                required
                                            />
                                            <label htmlFor="Surname">Last Name</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <select
                                                className="form-select"
                                                id="subject"
                                                value={formData.subject}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="" disabled>Choose an option</option>
                                                <option value="Corporate Shoots">Corporate Shoots</option>
                                                <option value="Fashion Photography">Fashion Photography</option>
                                                <option value="Food Photography">Food Photography</option>
                                                <option value="Interior Photography">Interior Photography</option>
                                                <option value="Product Photography">Product Photography</option>
                                            </select>
                                            <label htmlFor="subject">Subject</label>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="form-floating">
                                            <textarea
                                                className="form-control"
                                                placeholder="Leave a message here"
                                                id="message"
                                                style={{ height: 200 }}
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            <label htmlFor="message">Message</label>
                                        </div>
                                    </div>
                                    <div className="col-12 text-center">
                                        <button className="btn btn-primary py-3" type="submit" style={{ width: '620px' }}>Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className='col-lg-6 mb-4'>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.466619580149!2d72.58419430920478!3d23.043348479072243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e853de3201c8b%3A0xaacf0b44f6d03054!2sWell%20Captured%20Hub!5e0!3m2!1sen!2sin!4v1735032448011!5m2!1sen!2sin" width="100%" style={{ height: 450 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Contact